import { render, staticRenderFns } from "./Checklists.vue?vue&type=template&id=7ce4a720"
import script from "./Checklists.vue?vue&type=script&lang=js"
export * from "./Checklists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce4a720')) {
      api.createRecord('7ce4a720', component.options)
    } else {
      api.reload('7ce4a720', component.options)
    }
    module.hot.accept("./Checklists.vue?vue&type=template&id=7ce4a720", function () {
      api.rerender('7ce4a720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/Checklists.vue"
export default component.exports